import React from 'react';
import PropTypes from 'prop-types';
import styles from '../Footer.module.scss';

const Comparison = ({ omitHeading = false }) => {
  return (
    <ul className={styles.linkList}>
      {!omitHeading && (
        <li>
          <a href="/freelancers">Comparison</a>
        </li>
      )}
      <li>
        <a href="/blog/the-10-best-alternatives-to-upwork/">Twine vs Upwork</a>
      </li>
      <li>
        <a href="/blog/the-10-best-alternatives-to-fiverr/">Twine vs Fiverr</a>
      </li>
      <li>
        <a href="/blog/the-10-best-alternatives-to-99designs/">
          Twine vs 99Designs
        </a>
      </li>
      <li>
        <a href="/blog/the-10-best-alternatives-to-toptal/">Twine vs Toptal</a>
      </li>
      <li>
        <a href="/blog/the-10-best-alternatives-to-linkedin/">
          Twine vs LinkedIn
        </a>
      </li>
    </ul>
  );
};

Comparison.propTypes = {
  omitHeading: PropTypes.bool,
};

export default Comparison;
